/* List of Redux constants */
export const CANDIDATE_PROFILE_REVISION_COMPARISON_SET_COMPARED_DATA_LOADING = '@candidate-profile-revision-comparison/set-compared-data-loading';
export const CANDIDATE_PROFILE_REVISION_COMPARISON_SET_COMPARED_DATA = '@candidate-profile-revision-comparison/set-compared-data';
export const CANDIDATE_PROFILE_REVISION_COMPARISON_RESET_COMPARED_DATA = '@candidate-profile-revision-comparison/reset-compared-data';

/* List of Sagas constants */
export const CANDIDATE_PROFILE_REVISION_COMPARISON_GET_COMPARED_DATA = '@candidate-profile-revision-comparison/get-compared-data';


// WEBPACK FOOTER //
// ./src/actions/candidate/candidate-profile-revision/comparison/types.js